/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="comment-sticky"
    @click.prevent="stickyClicked"
  >
    <tooltip
      placement="bottom"
      trigger="hover"
      :content="getContent(comment)"
    >
      <svg
        :id="'#commentSticky-' + comment.feedbackId"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M11.0944 0C5.08444 0 1.18444 3.86 0.204444 10.91C-0.255556 14.21 0.204444 21.82 0.204444 21.82C0.204444 21.82 7.99444 22.21 11.1044 21.82C17.4444 21.04 21.9944 16.94 21.9944 10.91C21.9944 4.89 17.1144 0 11.0944 0Z"
            fill="#F66620"
          />
          <text
            class="comment-sticky-text"
            stroke="#fff"
            x="6"
            y="15"
          >
            C
          </text>
        </g>
      </svg>
    </tooltip>
  </div>
</template>

<style lang="less" scoped>
  .comment-sticky-text {
    font: 12px sans-serif;
    fill: #fff;
  }
  .comment-sticky {
    cursor: pointer;
    z-index: 70;
    position: absolute;
    top: 40px;
    left: -80px;
  }
</style>

<script>
import Tooltip from 'vue-strap/src/Tooltip';

export default {
  components: {Tooltip},
  props: ['recording', 'wavesurfer', 'comment', 'speakerNum'],
  computed: {
    isVideo: {
      cache: false,
      get() {
        if (!this.recording || !this.recording.isVideo) {
          // Non-videos are always not video
          return false;
        }

        if (this.preferences && this.preferences[this.recording.recordingId] && this.preferences[this.recording.recordingId].hideVideo) {
          // Videos with a saved hideVideo preference are not videos
          return false;
        }

        // Other videos ARE videos
        return true;
      },
    },
    preferences() {
      return this.$store.getters.preferences;
    },
    isConversational() {
      return !!(this.recording && this.recording.results && this.recording.results.isConversational);
    },
    wavesurferWidth: {
      cache: false,
      get() {
        return document.getElementById('wavesurferContainer').offsetWidth;
      }
    },
    positionPercent() {
      if (!this.wavesurfer) return;

      const playbackLength = this.wavesurfer.getDuration();
      const start = this.comment.regionStart;
      return start / playbackLength;
    }
  },
  created() {
    window.addEventListener('resize', this.setStickyPosition);
    window.setTimeout(this.setStickyPosition, 500);
  },
  updated() {
    window.setTimeout(this.setStickyPosition, 500);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.setStickyPosition);
  },
  methods: {
    getContent(comment) {
      let content = comment.comment;
      content += `\n  --`;  // eslint-disable-line quotes
      content += comment.name || 'User ';
      return content;
    },
    stickyClicked() {
      const _id = 'showRegionLink-' + this.comment.feedbackId;
      document.getElementById(_id).click();
    },
    setStickyPosition() {
      const leftOffset = this.positionPercent * this.wavesurferWidth;
      this.$el.style.left = leftOffset + 'px';

      let topOffset = 70;
      if (!this.isVideo && (this.speakerNum && this.speakerNum > 0)) {
        // Convo with identified speaker
        topOffset = 85 * (window.parseInt(this.speakerNum, 10) + 1);
      } else if (!this.isVideo && this.isConversational) {
        // Convo with no identified speaker
        topOffset = 75;
      }
      this.$el.style.top = topOffset + 'px';
    }
  }
};
</script>
